import React, { useContext, useState } from 'react';
import './Modal.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';
import { Button, Modal, PageRibbon } from '../../importCL';
interface IChildren {
  children: React.ReactNode;
}

interface IAlternateSpeedbump {
    title: string;
    content: string;
}

interface IModalContextValue {
  isOpen: boolean;
  toggleModal: () => void;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setModalContent: React.Dispatch<React.SetStateAction<React.ReactElement>>;
  setModalClass: React.Dispatch<React.SetStateAction<string>>;
  setExitAnimationDuration: React.Dispatch<React.SetStateAction<number>>;
  setExitAnimationClass: React.Dispatch<React.SetStateAction<string>>;
}

export const ModalContext = React.createContext<IModalContextValue>({
    isOpen: false,
    toggleModal: () => {},
    setModalOpen: () => {},
    setModalContent: () => {},
    setModalClass: () => {},
    setExitAnimationDuration: () => {},
    setExitAnimationClass: () => {},
});

function checkUrl(externalUrl: string) {
    const jsonObject = JSON.parse(PathUtils.getMetaPropertyValue('speedbumpContent') || '{}');
    
    if (jsonObject?.alternateSpeedbumps) {
        for (let i = 0; i < jsonObject.alternateSpeedbumps.length; i++) {
            if (externalUrl.includes(jsonObject.alternateSpeedbumps[i].url)) {
                const newSpeedbumpInfo = jsonObject.alternateSpeedbumps[i];
                const newSpeedbump: IAlternateSpeedbump = { title: newSpeedbumpInfo.title, content: newSpeedbumpInfo.content };
                return newSpeedbump;
            }
        }
    }
    
    return null;
}

export const speedbumpModal = (toggleModal: () => void, width: number, target?: '_blank' | '_self' | undefined, externalUrl?: string | undefined, title?: string, content?: string): JSX.Element => {
    let newSpeedbump = null;

    if (externalUrl !== undefined) {
        newSpeedbump = checkUrl(externalUrl);
    }

    
    if (newSpeedbump && newSpeedbump.title !== null && newSpeedbump.content !== null) {
        title = newSpeedbump.title;
        content = newSpeedbump.content;
    }
    
    return (
        <div className='Speedbump__contentContainer'>
            <PageRibbon>{title}</PageRibbon>
            <div className='Speedbump__scrollBox'>
                <div className='p-4 Speedbump__content'>{transformHTMLParserLinks(content ?? '')}</div>
            </div>
            <div className='Speedbump__fade'></div>
            <div className='Speedbump__controls'>
                {(width > 768) && <Button className='Speedbump__returnButton' size='medium' variant='ghosted-dark' onClick={toggleModal}>
                    Return to CreditOneBank.com
                </Button>}
                <Button className='Speedbump__continueButton' size='medium' variant='solid' href={externalUrl} target={target} onClick={toggleModal}>
                    Continue
                </Button>
                {(width <= 768) && <Button className='Speedbump__returnButton' size='medium' variant='ghosted-dark' onClick={toggleModal}>
                    Return to CreditOneBank.com
                </Button>}
            </div>
        </div>
    );
};

export const ModalProvider = (props: IChildren) => {
    const [isOpen, setModalOpen] = useState(false);
    const [exitAnimationDuration, setExitAnimationDuration] = useState(0);
    const [exitAnimationClass, setExitAnimationClass] = useState('');
    const [modalContent, setModalContent] = useState<React.ReactElement>(
        <div/>,
    );
    const [modalClass, setModalClass] = useState('');

    const toggleModal = () => {
        setModalOpen((isOpen) => !isOpen);
    };

    return (
        <ModalContext.Provider
            value={{
                isOpen,
                toggleModal,
                setModalOpen,
                setModalContent,
                setModalClass,
                setExitAnimationDuration,
                setExitAnimationClass,
            }}
        >
            {props.children}
            <Modal isOpen={isOpen} modalOpen={setModalOpen} className={modalClass} exitAnimationDuration={exitAnimationDuration} exitAnimationClass={exitAnimationClass}>
                {modalContent}
            </Modal>
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);
